import { ErrorBoundary } from '@/components/ErrorBoundary';
import { CreditByMonthSection } from '@/components/analytics/CreditByMonth';
import { PerformanceMetrics } from '@/components/analytics/PerformanceMetrics';
import { PnlHistoryChart, CHART_TYPES, type ChartType } from '@/components/analytics/PnlHistoryChart';
import { PremiumFlowSankey } from '@/components/analytics/PremiumFlowSankey';
import { StrategyBreakdown } from '@/components/analytics/StrategyBreakdown';
import { SymbolBreakdown } from '@/components/analytics/SymbolBreakdown';
import { DEFAULT_PERIOD, PERIOD_VALUES, type Period } from '@/components/analytics/periods';
import { useUrlParam } from '@/hooks/useUrlState';

export function AnalyticsPage() {
  // One period for the page, not one per widget: a shared link should open on the same window
  // of history in both charts, and two independent selectors on one screen read as a bug.
  const [period, setPeriod] = useUrlParam<Period>('period', DEFAULT_PERIOD, PERIOD_VALUES);
  const [chartType, setChartType] = useUrlParam<ChartType>('chart', 'cumulative', CHART_TYPES);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Analytics</h1>
        <p className="text-sm text-gray-500 mt-1">
          Detailed analysis of your trading performance
        </p>
      </div>

      <ErrorBoundary>
        <PerformanceMetrics />
      </ErrorBoundary>
      <ErrorBoundary>
        <PnlHistoryChart
          period={period}
          onPeriodChange={setPeriod}
          chartType={chartType}
          onChartTypeChange={setChartType}
        />
      </ErrorBoundary>
      <ErrorBoundary>
        <PremiumFlowSankey period={period} onPeriodChange={setPeriod} />
      </ErrorBoundary>
      <ErrorBoundary>
        <CreditByMonthSection />
      </ErrorBoundary>
      <ErrorBoundary>
        <StrategyBreakdown />
      </ErrorBoundary>
      <ErrorBoundary>
        <SymbolBreakdown />
      </ErrorBoundary>
    </div>
  );
}
